import { DialogActions as MuiDialogActions } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useFeedbackButtonsContext } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/hooks';
import { Button } from 'shared/components/buttons/Button';
import { LoadingButton } from 'shared/components/buttons/LoadingButton';

import type { FC } from 'react';

export const DialogActions: FC = () => {
  const { t } = useTranslation();
  const { onClose } = useFeedbackButtonsContext();
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  return (
    <MuiDialogActions>
      <Button onClick={onClose}>
        {t(
          'GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.cancelButton',
        )}
      </Button>
      <LoadingButton
        type="submit"
        sx={{ borderRadius: '24px' }}
        variant="contained"
        disabled={!isValid}
        loading={isSubmitting}
      >
        {t(
          'GSP.pages.parentHelper.chat.body.feedbackDislikeDialog.submitFeedbackButton',
        )}
      </LoadingButton>
    </MuiDialogActions>
  );
};
